<div class="logout-container">
    <div class="logout-content">
        <div class="column-1">
            <div class="graphic"></div>
        </div>
        <div class="column-2">
            <div class="text-container">
                <span class="text">{{this.thankYouLabel}}</span>
            </div>
            <div class="button-container">
                <div class="button-wrapper" (click)="redirectToLogin()">
                    <span>{{this.loginLabel}}</span>
                </div>
            </div>
        </div>
    </div>
</div>